import AnimatedCarouselSlide, {
  AnimatedCarouselSlideProps,
} from "./AnimatedCarouselSlide";

export { AnimatedCarouselSlide, AnimatedCarouselSlideProps };

export default AnimatedCarouselSlide;
